module.exports = {
        srcSet: "https://static.sniffspot.com/packs/img/bp-6-393.2c4d1f7b89a31dc1.jpg"+" 393w",
        images: [{path: "https://static.sniffspot.com/packs/img/bp-6-393.2c4d1f7b89a31dc1.jpg",width: 393,height: 262}],
        src: "https://static.sniffspot.com/packs/img/bp-6-393.2c4d1f7b89a31dc1.jpg",
        toString: function(){return "https://static.sniffspot.com/packs/img/bp-6-393.2c4d1f7b89a31dc1.jpg"},
        
        width: 393,
        height: 262
      }